<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!--___________Form_____________ -->
    <v-card>
      <!-- {{ formSchema }} -->
      <!-- Confirmation box -->
      <v-layout row justify-center>
        <v-dialog v-model="confirmDialog" max-width="70%">
          <v-card>
            <v-btn color="primary" v-on:click="printdiv" style="float:right">
              <v-icon>print</v-icon> Print
            </v-btn>
            <v-card-title>
              <span class="headline">Is your information correct?</span>
            </v-card-title>
            <div id="print-area">
              <hr />
              <v-card-text>
                <table>
                  <tr>
                    <td>Loan Number</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.loan_no }}</td>
                  </tr>

                  <tr>
                    <td>Last Interest Reset Date</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ changeFormateDMY(formSchema.reset_date) }}</td>
                  </tr>

                  <tr>
                    <td>New Interest Reset Date</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.new_reset_date }}</td>
                  </tr>
                  <tr>
                    <td>Last Interest Rate</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.interest_rate }}</td>
                  </tr>
                  <tr>
                    <td>New Interest Rate</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.new_interest_rate }}</td>
                  </tr>
                  <tr>
                    <td>Last Reset No</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.reset_no }}</td>
                  </tr>

                  <tr>
                    <td>New Reset No</td>
                    <td>&nbsp; : &nbsp;</td>
                    <td>{{ formSchema.reset_no + 1 }}</td>
                  </tr>
                </table>
              </v-card-text>

              </br>
              <table class="paySchedule">
                <tbody v-if="formSchema.unpaid_installment && formSchema.unpaid_installment.length>0">
                  <tr class="textCenter">
                    <th colspan="5" style="font-size: 20px;">Unpaid Installment Calculation</th>
                  </tr>
                  <tr class="tb-td">
                    <th>Due Installment Date</th>
                    <th> Installment Size</th>
                    <th>Over Due Days</th>
                    <th>Over Due Interest</th>
                    <th> Total Installment </th>
                  </tr>
                  <!-- __________________ Debit Row _________________ -->
                  <tr v-for="(inst_data, index) in formSchema.unpaid_installment" :key=index>
                    
                    <td class="textCenter">
                      {{dateStringMonth(inst_data.installment_date)}}
                    </td>
                    <td class="textCenter">
                      {{inst_data.intallmentSize | currency}}
                    </td>
                    <td class="textCenter">
                      {{inst_data.total_Days}}
                    </td>
                    <td class="textCenter">
                      {{inst_data.dueInterest | currency}}
                    </td>
                    <td class="textCenter">
                      {{inst_data.total_size | currency}}
                    </td>
                  </tr>
                  <!-- __________________ /Debit Row _________________ -->
                  <tr >
                    <th colspan="4" class="textRight">Total Due Installment</th>
                    <th> {{formSchema.sum_installment | currency}} </th>
                  </tr>


                </tbody>
              </table>
              <hr>

              <table class="paySchedule">
                <tbody v-if="partialPayDataset && partialPayDataset.length>0">
                  <tr class="textCenter">
                    <th colspan="5" style="font-size: 20px;">Adjust Partial Payment</th>
                  </tr>
                  <tr class="tb-td">
                    <th>Recieve Date</th>
                    <th>Pay Amount</th>
                    <th>Total Days</th>
                    <th> Reduce Interest Amount </th>
                    <th> Total Partial Pay Amount </th>
                  </tr>
                  <!-- __________________ Debit Row _________________ -->
                  <tr v-for="(pay_data, index) in partialPayDataset" :key=index>
                    
                    <td class="textCenter">
                      {{dateStringMonth(pay_data.receive_date )}}
                    </td>
                    <td class="textCenter">
                      {{pay_data.payAmount | currency}}
                    </td>
                    <td class="textCenter">
                      {{pay_data.totalDay}}
                    </td>
                    <td class="textCenter">
                      {{pay_data.reduceInterest | currency}}
                    </td>
                    <td class="textCenter">
                      {{pay_data.total_partial_amount | currency}}
                    </td>
                  </tr>
                  <!-- __________________ /Debit Row _________________ -->
                  <tr >
                    <th colspan="4" class="textRight">Total Partial Pay Amount</th>
                    <th> {{(partialPayDataset && partialPayDataset.length>0) ? partialPayDataset[0].sum_partial_amount : 0 | currency}} </th>
                  </tr>


                </tbody>
              </table>
              <hr>

              </br>
              <table class="paySchedule">
                <tbody>
                  <tr class="textCenter">
                    <th colspan="8" style="font-size: 20px;">Outstanding Calculation</th>
                  </tr>
                  <tr class="tb-td">
                    <th> Outstanding <br> (A) </th>
                    <th>Unpaid Amount <br> (B)</th>
                    <th> Partial Amount <br> (C)</th>
                    <th>Total Outstanding <br> (A+B) - (C)</th>
                  </tr>
                  <!-- __________________ Debit Row _________________ -->
                  <tr>
                    <td class="textCenter">
                      {{formSchema.outstanding | currency}}
                    </td>
                    <td class="textCenter">
                      {{formSchema.sum_installment | currency}}
                    </td>
                    <td class="textCenter">
                      {{(partialPayDataset && partialPayDataset.length>0) ? partialPayDataset[0].sum_partial_amount : 0 | currency}}
                    </td>
                    <td class="textCenter">
                      {{ ((parseFloat(formSchema.outstanding) + parseFloat(formSchema.sum_installment)) - parseFloat((partialPayDataset && partialPayDataset.length>0) ? partialPayDataset[0].sum_partial_amount : 0) ) | currency}}
                    </td>
                  </tr>
                  <!-- __________________ /Debit Row _________________ -->

                </tbody>
              </table>
              <hr />
            </div>  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click.native="confirmDialog = false">
                No
              </v-btn>
              <v-btn color="success" @click.native="submitForm">
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- /Confirmation box -->

      <v-card-title class="pb-0">
        <span class="headline">Loan Reset Interest</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Loan No *"
                  v-model="formSchema.loan_no"
                  :rules="[(v) => !!v || 'Loan no is required !']"
                  required
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4 v-show="false">
                <v-text-field
                  label="Last Interest Reset Date *"
                  v-model="formSchema.reset_date"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Last Reset No *"
                  v-model="formSchema.reset_no"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Last Interest Rate *"
                  v-model="formSchema.interest_rate"
                  :rules="[(v) => !!v || 'Last interest rate is required !']"
                  required
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="New Interest Rate *"
                  v-model="formSchema.new_interest_rate"
                  :rules="[
                    (v) => !!v || 'New interest rate is required !',
                    spaces,
                    decimal,
                  ]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{
                    index: 1,
                    fieldName: 'new_reset_date',
                    fieldValue: formSchema.new_reset_date,
                    label: 'New Interest Reset Date *',
                    required: '1',
                  }"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                v-if="saveBtn"
                @click.native="confirmation"
                :disabled="!valid"
              >
                <v-icon>save</v-icon>
                Submit
              </v-btn>
              <v-btn color="error" @click="previous">
                <v-icon>arrow_back_ios</v-icon>Previous
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/Form_____________ -->
  </div>
</template>

<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

import Axios from "axios";

export default {
  components: {
    DatePicker,
  },

  data: () => ({
    valid: true,
    saveBtn: true,

    leaveTypeModal: false,
    detailObject: "",
    confirmDialog: false,
    EcoCodeInfoList: [],
    DisbursementAccountList: [],
    partialPayDataset : [],
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },

    formSchema: {
      disbursement_date: "",
      loan_id: "",
      loan_no: "",
      loan_amount: "",
      disbursement_account: "",
      economic_code_id: "",
      available_amount: "",
      transaction_currency: "",
      fund_source: "",
      disbursement_amount: "",
      currency_rate: "",
      today_disbursement: "",
      re_schedule_no: "",
      formName: 3, // Loan Reset
    },

    debit: {
      eco_code_id: "",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "Ins",
    },

    credit: {
      eco_code_id: "",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "D",
    },
  }),

  created() {

    let info = this.$store.getters.GET_COMMON_DATA;

    if (info) {
      this.DisbursementAccountList.push(info.disbursement_accountInfo);      
      

      let initialDate =
        info.reset_date != "0000-00-00" ? info.reset_date : info.loan_date;
      let resetDate = new Date(this.dateStringMonth(initialDate));
      // console.log('Initial Date For',resetDate);  
      // let tempdate = resetDate.setMonth(resetDate.getMonth() + parseInt(info.interest_by_month));
      // let nextResetdate = new Date(tempdate);
      // nextResetdate = nextResetdate.toJSON().substring(0, 10);
      info.new_reset_date = this.changeFormateDMY(info.new_reset_date);
      this.formSchema.reset_date =
        info.reset_date != "0000-00-00"
          ? this.changeFormateDMY(info.reset_date)
          : "";

      // Installment Number Set for reset
      info.pre_loan_period_in_month = info.loan_period_in_month;
      info.pre_repayment_period_in_month = info.repayment_period_in_month;
      
      if(info.loan_period_in_month > info.repayment_period_in_month){
        //Sub grace period reduce from profile
        if(info.grace_period_in_month == info.sub_grace_period_in_month && info.sub_grace_period_in_month != 0){
          info.sub_grace_period_in_month = (parseInt(info.sub_grace_period_in_month) - parseInt(info.interest_by_month));
        }
        info.loan_period_in_month = (info.loan_period_in_month - parseInt(info.interest_by_month));
        info.grace_period_in_month = (info.grace_period_in_month - parseInt(info.interest_by_month));
      }else{
        info.loan_period_in_month = (info.loan_period_in_month - parseInt(info.interest_by_month));
        info.repayment_period_in_month = (info.repayment_period_in_month - parseInt(info.interest_by_month));
      }
      info.loan_amount = info.old_opening_principal;
      info.overdue_interest_rate = '';
      this.formSchema = info;


      //Partial Payment Adjustment if exist ============================ 

      var queryData = {
        'loan_id': info.loan_id ,
        'end_date': this.changeFormateYMD(info.new_reset_date),
        'interest_rate' : this.formSchema.interest_rate
        };
      commonService
        .getServerSideData(queryData,"get_partial_data")
        .then(res => {
          this.partialPayDataset = res.partialPayData;
          this.formSchema.unpaid_installment = res.unpaid_installment;
          this.formSchema.sum_installment = res.sum_installment;
          this.formSchema.outstanding = res.outstanding;
          
          var sum_partial_amount = (this.partialPayDataset && this.partialPayDataset.length>0) ? this.partialPayDataset[0].sum_partial_amount : 0;
          var new_loan_amount = (
                (parseFloat(this.formSchema.outstanding) + 
                parseFloat(this.formSchema.sum_installment)) -
                parseFloat(sum_partial_amount)
              );
            this.formSchema.loan_amount = this.numberFormate(new_loan_amount);  

          this.$store.commit('UNSET_KEY_VALUE');
          this.$store.commit('SET_KEY_VALUE', this.partialPayDataset); 
          //console.log('currentAmount_val',this.partialPayDataset);
     });
    
    

    }

  /*
    created() {
    let info = this.$store.getters.GET_COMMON_DATA;
    if (info) {
      this.DisbursementAccountList.push(info.disbursement_accountInfo);
      this.formSchema = info;
      console.log("info.reset_date", info);
      let initialDate =
        info.reset_date != "0000-00-00" ? info.reset_date : info.loan_date;
      let resetDate = new Date(initialDate);
      let tempdate = resetDate.setMonth(resetDate.getMonth() + parseInt(5));
      let nextResetdate = new Date(tempdate);
      nextResetdate = nextResetdate.toJSON().substring(0, 10);
      info.new_reset_date = this.changeFormateDMY(nextResetdate);
      this.formSchema.reset_date =
        info.reset_date != "0000-00-00"
          ? this.changeFormateDMY(info.reset_date)
          : "";
    }*/

    commonService.getAllData("get-dis-dropdown-data").then((res) => {
      this.EcoCodeInfoList = res.EcoCodeInfoList;
    });

    if (!this.formSchema.loan_id) {
      this.$router.push("/on-lending/search-loan-reset");
    }
  },

  methods: {
    
    // To get Next date
    nextDate(date){
        var result = new Date(date);
        result.setDate(result.getDate() + 1);
        var edate = new Date(result);
        return edate.toJSON().substring(0,10);
    },

    // get partial payment data from here
    getPartialPayData(loan_id,end_date){
      var queryData = {
        'loan_id': loan_id ,
        'end_date': this.changeFormateYMD(end_date)
        };
      commonService
        .getServerSideData(queryData,"get_partial_data")
        .then(res => {
          //this.lamSum_amount = res.partial_amount;
          console.log('Payyyy',res);
          return res;
        });
    },

    getTotalDays(startDate, endDate)
    {
        //const startDate  = '2035-09-01';
        //const endDate    = '2035-10-01';
        console.log("startDate=" + startDate + " endDate=" + endDate);

        if((startDate != "" || startDate != "0000-00-00") && (endDate != "" || endDate != "0000-00-00") )
        {
          const diffInMs   = new Date(endDate) - new Date(startDate)
          const totalDays = diffInMs / (1000 * 60 * 60 * 24) + Number(1);
          console.log('totalDays', totalDays);        
          return totalDays;
        }
        return 0;
    },

    submitForm() {
      let root = this;

      var formSchema = this.formSchema;
      formSchema.formName = "Reset"; // 3; // Loan Reset

      /*formSchema.interest_rate = formSchema.new_interest_rate;
      formSchema.new_reset_date = this.changeFormateDMY(
              formSchema.new_reset_date
            );

      formSchema.reset_no = formSchema.reset_no+1;
      formSchema.loan_amount = formSchema.old_opening_principal;
      formSchema.old_opening_principal = formSchema.old_opening_principal;*/

      //formSchema.old_opening_principal = formSchema.old_opening_principal

      //console.log("formSchema", formSchema);
      formSchema.loan_date = formSchema.new_reset_date;
      this.$store.commit("SET_COMMON_DATA", formSchema);
      this.$router.push("/on-lending/loan-profile-stepform");

      //formSchema.currency = formSchema.transaction_currency

      //formSchema.disbursement_date = this.changeFormateYMD(formSchema.disbursement_date);
      /*parseFloat(formSchema.interest_rate).toFixed(2);
      
      let formData = new FormData();

      formData.append("formSchema", JSON.stringify(this.formSchema));
      formData.append("debit", JSON.stringify(this.debit));
      formData.append("credit", JSON.stringify(this.credit));

        commonService
          .insertFormData(formData, "loan-disbursement")
          .then(res => {

            if(res.status == 1)
            {       
              this.saveBtn = false;       
              this.SnackbarVal.color = "success"
              this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
              this.confirmDialog = false;
            }
            else
            {
              this.SnackbarVal.color = "error"
            }
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;

            setTimeout(function() {
              root.$router.push("/on-lending/search-disbursement");       
            }, 3000);

          });*/
    },

    confirmation() {
      let formSchema = this.formSchema;
      if (this.$refs.form.validate()) {
        this.confirmDialog = true;
      }
    },

    changeDisbursementAmt(val) {
      let dis = this.DisbursementAccountList.filter(function(a) {
        return a.eco_account_name == val;
      })[0];

      let credit = this.credit;
      credit.eco_code_id = dis.id;
      credit.eco_code = dis.eco_account_code;
      credit.account_name = dis.eco_account_name;
    },

    /* {{this.EcoCodeInfoList}}*/
    changeEcoCode(val) {
      let eco = this.EcoCodeInfoList.filter(function(a) {
        return a.id == val;
      })[0];

      let debit = this.debit;
      debit.eco_code_id = eco.id;
      debit.eco_code = eco.eco_account_code;
      debit.account_name = eco.eco_account_name;
    },

    setDateValue(data) {      
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    previous() {
      this.$store.commit("UNSET_COMMON_DATA");
      this.$router.push("/on-lending/search-loan-reset");
    },

    changeAmount(todayDisbursementAmount) {
      let formSchema = this.formSchema;
      let available_amount = Number(formSchema.available_amount);
      let todayPayAmount = Number(todayDisbursementAmount);

      if (available_amount < todayPayAmount) {
        formSchema.today_disbursement = 0;
        this.SnackbarVal.message =
          "Today disbursement amount will be less than or equal of available amount";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
      }
      this.setVoucherData();
    },

    numberFormate(numBer) {
      if (numBer != "-") {
        //return Number(numBer).toFixed(4);
        return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      } else {
        return "0.00";
      }
    },

    setVoucherData() {
      let formSchema = this.formSchema;
      let debit = this.debit;
      let credit = this.credit;

      debit.tr_debit = formSchema.today_disbursement;
      debit.tr_credit = 0;
      debit.currency = formSchema.transaction_currency;
      debit.bdt_debit = formSchema.today_disbursement;
      debit.bdt_credit = 0;
      debit.usd_debit = this.numberFormate(
        formSchema.today_disbursement / formSchema.currency_rate
      );
      debit.usd_credit = 0;
      debit.src_fund = formSchema.fund_source;
      debit.loan_no = formSchema.loan_no;

      credit.tr_debit = 0;
      credit.tr_credit = formSchema.today_disbursement;
      credit.currency = formSchema.transaction_currency;
      credit.bdt_debit = 0;
      credit.bdt_credit = formSchema.today_disbursement;
      credit.usd_debit = 0;
      credit.usd_credit = this.numberFormate(
        formSchema.today_disbursement / formSchema.currency_rate
      );
      credit.src_fund = formSchema.fund_source;
      credit.loan_no = formSchema.loan_no;
    },
    printdiv: function () {
          this.printContentStatus = true;
          const divToPrint = document.getElementById("print-area");
          this.printContentStatus = false;
          const newWin = window.open("", "Print-Window");
          newWin.document.open();
          newWin.document.write(
              '<style type="text/css">'+
              'table.paySchedule{ width:100%; border-collapse: collapse; }'+
              '.paySchedule th{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule td{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule tr.tb-td td{font-weight: bold; text-align:center;}'+
              'td.textCenter{text-align: center;}'+
              'td.textRight{text-align: right;}'+
              '#prescriptions_bgImgs{position: absolute; left: 35%; background-repeat: no-repeat;'+
              'background-position: center; background-size: cover; opacity: 0.1; top: 30%; }.paySchedule tr.borderNone td,.paySchedule td.borderNone{border:none !important;}'+
              "</style>"
          );
          newWin.document.write(
              '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
              divToPrint.innerHTML +
              "</body></html>"
          );

          newWin.document.close();
          setTimeout(function () {
              newWin.close();
          }, 3000);
      },

  },

  computed: {},
};
</script>

<style scoped>
table.paySchedule {
  width: 100%;
  border-collapse: collapse;
}
.paySchedule th{
  border: 1px solid #CCC;
  text-align: center;
  padding: 0px;
}

.paySchedule td{
  border: 1px solid #CCC;
  line-height: 33px;  
  text-align: center;
  padding: 0px;
}

.paySchedule tr.tb-td td {
  font-weight: bold;
}
td.textCenter {
  text-align: center;
}
td.textRight {
  text-align: right;
}
td input {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/lending/loanReset/insert_form.vue